import { render } from "./Tabs.vue?vue&type=template&id=4555cfbc&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=4555cfbc&scoped=true&lang=css"

import exportComponent from "/opt/qyxs/qinyan_pro/qinyan_pro_client/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4555cfbc"]])

export default __exports__